// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 0.846924V16.9999C22 19.2091 20.2091 20.9999 18 20.9999C15.7909 20.9999 14 19.2091 14 16.9999C14 14.7908 15.7909 12.9999 18 12.9999C18.7286 12.9999 19.4117 13.1947 20 13.5351V3.15294L8 4.86723V18.9999C8 21.2091 6.20914 22.9999 4 22.9999C1.79086 22.9999 0 21.2091 0 18.9999C0 16.7908 1.79086 14.9999 4 14.9999C4.72857 14.9999 5.41165 15.1947 6 15.5351V3.13264L22 0.846924Z"}}]};

const Music1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'music-1-filled',
    ref,
    icon: element,
  },
));

Music1FilledIcon.displayName = 'Music1FilledIcon';

export default Music1FilledIcon;
